import { Address } from "./address";
import { AddressService } from "./addressService";
import { AddressRepositoryImpl } from "./addressRepositoryImpl";

/**
 * Controlador de endereços postais brasileiros via ViaCEP.
 */
export abstract class AddressController {
  private static readonly service = new AddressService(new AddressRepositoryImpl());

  /**
   * Consulta um endereço pelo CEP informado.
   * @param cep CEP contendo 8 dígitos numéricos (com ou sem hífen)
   * @returns Endereço correspondente ao CEP
   * @throws {Error} Quando o CEP não é encontrado ou a API retorna erro
   */
  static async findByCep(cep: string): Promise<Address> {
    return await AddressController.service.findByCep(cep);
  }
}
